<template>
  <div class="associate">
    <ul class="associate-list">
      <li v-for="item in list" @click="selectKey(item)" v-html="output(item)"></li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array
    },
    aKey: {
      type: String
    }
  },

  methods: {
    selectKey (item) {
      this.$emit('selectItem', item)
    },

    output (item) {
      const reg = new RegExp(`(${this.aKey})`, 'i')
    
      return item.name.replace(reg, '<span class="associate-key">$1</span>')
    }
  }
}
</script>

<style lang="stylus">

</style>





// WEBPACK FOOTER //
// associate-list.vue?c5ad6c66